<template>
  <v-layout row>
    <v-flex xs12 md10 offset-md1>
      <v-data-table class="edval-list" :items="flows" :headers="headers"
                    :pagination="flowPagination"
                    @update:pagination="setFlowPagination">
        <template slot="items" slot-scope="flow">
          <td>{{ flow.item.name }}</td>
          <td class="buttonCell">
            <v-btn icon flat :to="`/approvals/flows/${flow.item.id}`">
              <v-icon v-if="canModify">edit</v-icon>
              <v-icon v-else>visibility</v-icon>
            </v-btn>
            <v-btn v-if="canModify" icon flat @click="openDeleteModal(flow.item)">
              <v-icon color="error">delete</v-icon>
            </v-btn>
          </td>
        </template>
        <div class="push-left" slot="actions">
          <v-subheader v-if="canModify">
            Create flow
            <v-btn icon flat to="/approvals/flows/new">
              <v-icon color="success">add_box</v-icon>
            </v-btn>
          </v-subheader>
        </div>
      </v-data-table>
    </v-flex>
    <confirm-delete-modal v-model="deleteModal.show" :label="`approval flow ${deleteModal.flow.name}`"
                          @delete="deleteFlow"/>
  </v-layout>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import ConfirmDeleteModal from '@/views/shared/ConfirmDeleteModal';

  export default {
    components: { ConfirmDeleteModal },
    data() {
      return {
        headers: [
          { text: 'Flow', value: 'name' }
        ],
        deleteModal: {
          show: false,
          flow: {}
        }
      };
    },
    computed: {
      canModify() {
        return this.$auth.hasPermission('EDIT_ALL_USERS');
      },
      ...mapState('approvals', [
        'flows',
        'flowPagination'
      ])
    },
    methods: {
      openDeleteModal(flow) {
        this.deleteModal = {
          show: true,
          flow
        };
      },
      deleteFlow() {
        this.$services.authenticator.delete(`/approvals/flows/${this.deleteModal.flow.id}`)
          .then(() => this.initializeFlows(true))
          .catch(this.$defaultHandlerHttp);
      },
      ...mapActions('approvals', [
        'initializeFlows',
        'setFlowPagination'
      ])
    },
    mounted() {
      this.initializeFlows()
        .catch(this.$defaultHandlerHttp);
    }
  };
</script>

<style scoped lang="less">
  @import '../../../style/list.less';
</style>
